import type { TFunction } from "i18next";

export type PageName =
  "explore" | "asset" | "portfolio" | "fundraising" | "platform";
export type Localize = TFunction<"translation">;
export const portfolioTabs = [
  "assets",
  "rewards",
  "points",
  "invite",
  "vesting",
  "records",
] as const;
export type MyTab = (typeof portfolioTabs)[number];
export const platformTokenTabs = [
  "overview",
  "buyback",
  "integration",
] as const;
export type TokenTab = (typeof platformTokenTabs)[number];
export const platformTokenRouteTabs = ["buyback", "integration"] as const;
export type ExploreFilter = "all" | "near" | "graduated";
export type AssetTab = "trades" | "holders";
export type RecordFilter =
  "all" | "trade" | "claim" | "invite" | "graduation" | "transfer";
export type RequireWalletAction = (action?: () => void) => void;
